export default {
  bottomNavList: state => state.bottomNavList,
  footerList: state => state.footerList,
  newPageCurrent: state => state.newPageCurrent,
  checkPage: state => state.checkPage,
  previewData: state => state.previewData,
  updating: state => state.updating,
  isLoadingList: state => state.isLoadingList,
};
